module.exports = __webpack_public_path__ + "static/media/47e08118-5050-469b-a40c-dc3b2307e87e.f8903173.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274151/47e08118-5050-469b-a40c-dc3b2307e87e.ttf
// module id = 1667
// module chunks = 2